const APP_BASE_PATH = '/app';
const AUTH_RETURN_TO_STORAGE_KEY = 'hit-auth-return-to';

export const publicRoutes = {
  landing: '/',
  help: '/hilfe',
  privacy: '/datenschutz',
  callback: '/callback',
} as const;

export const appRoutes = {
  dashboard: APP_BASE_PATH,
  events: `${APP_BASE_PATH}/events`,
  news: `${APP_BASE_PATH}/news`,
  members: `${APP_BASE_PATH}/members`,
  profile: `${APP_BASE_PATH}/profile`,
  admin: `${APP_BASE_PATH}/verwaltung`,
  platformAdmin: `${APP_BASE_PATH}/plattform-admin`,
  bexioCallback: `${APP_BASE_PATH}/verwaltung/bexio/callback`,
} as const;

export function eventPath(eventId: string) {
  return `${appRoutes.events}/${eventId}`;
}

export function newsPath(newsId: string) {
  return `${appRoutes.news}/${newsId}`;
}

export function memberPath(memberId: string) {
  return `${appRoutes.members}/${memberId}`;
}

/** Whether `pathname` is `routePath` or one of its sub-pages. The dashboard only matches itself unless `includeNested`. */
export function isAppRouteActive(
  pathname: string,
  routePath: string,
  includeNested = routePath !== appRoutes.dashboard,
) {
  return pathname === routePath || (includeNested && pathname.startsWith(`${routePath}/`));
}

export function legacyToAppPath(pathname: string) {
  if (pathname === '/events' || pathname.startsWith('/events/')) return `${APP_BASE_PATH}${pathname}`;
  if (pathname === '/news' || pathname.startsWith('/news/')) return `${APP_BASE_PATH}${pathname}`;
  if (pathname === '/members' || pathname.startsWith('/members/')) return `${APP_BASE_PATH}${pathname}`;
  if (pathname === '/profile') return appRoutes.profile;
  if (pathname === '/verwaltung' || pathname.startsWith('/verwaltung/')) return `${APP_BASE_PATH}${pathname}`;
  if (pathname === '/plattform-admin') return appRoutes.platformAdmin;
  return appRoutes.dashboard;
}

/** Only same-origin paths inside the app may be used as post-login redirect targets. */
export function isSafeAuthReturnTo(value: string | null | undefined): value is string {
  if (!value?.startsWith(APP_BASE_PATH) || value.startsWith('//')) return false;
  try {
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin && isAppRouteActive(url.pathname, APP_BASE_PATH, true);
  } catch {
    return false;
  }
}

export function storeAuthReturnTo(value: string) {
  if (!isSafeAuthReturnTo(value)) return;
  window.sessionStorage.setItem(AUTH_RETURN_TO_STORAGE_KEY, value);
}

export function consumeAuthReturnTo() {
  const storedValue = window.sessionStorage.getItem(AUTH_RETURN_TO_STORAGE_KEY);
  window.sessionStorage.removeItem(AUTH_RETURN_TO_STORAGE_KEY);
  return isSafeAuthReturnTo(storedValue) ? storedValue : appRoutes.dashboard;
}
